import React, { CSSProperties, ReactElement } from "react";

import { useIntl } from "gatsby-plugin-react-intl";
import Select, { components, DropdownIndicatorProps } from "react-select";

import { DropdownItemProps } from "./dropdownItem";
import { ReactComponent as IconDropdownExpand18 } from "../../icons/icon/18/a-icon-dropdown-expand-18.svg";
import { ReactComponent as IconDropdownMinimize18 } from "../../icons/icon/18/a-icon-dropdown-minimize-18.svg";

import "./dropdownLanguage.scss";

interface DropdownLanguageItem {
  item: ReactElement<DropdownItemProps>;
  value: string;
  url?: string;
}

interface DropdownLanguageProps {
  id: string;
  dropdownItems: DropdownLanguageItem[];
}

const DropdownLanguage: React.FC<DropdownLanguageProps> = ({ id, dropdownItems }) => {
  let activeIndex = 0;
  let maxLength = 0;

  const intl = useIntl();

  dropdownItems.forEach((dropdownItem, key) => {
    if (dropdownItem.item.props.active) {
      activeIndex = key;
    }

    if (dropdownItem.item.props.text.length > maxLength) {
      maxLength = dropdownItem.item.props.text.length;
    }
  });

  const maxWidthElements = { maxWidth: `${8 * maxLength + 100}px` };
  const cursorPointer = { cursor: "pointer" };

  const indicator = (options: DropdownIndicatorProps<DropdownLanguageItem>) => {
    const { selectProps } = options;

    return (
      <components.DropdownIndicator {...options}>
        {selectProps.menuIsOpen
          ? <IconDropdownMinimize18 />
          : <IconDropdownExpand18 />}
      </components.DropdownIndicator>
    );
  };

  return (
    <Select
      components={{
        DropdownIndicator: indicator,
        IndicatorSeparator: () => null,
      }}
      id={id}
      isSearchable={false}
      defaultValue={dropdownItems[activeIndex]}
      options={dropdownItems}
      formatOptionLabel={(data: DropdownLanguageItem) => data.item}
      hideSelectedOptions
      onChange={(data: DropdownLanguageItem) => {
        if (window && data) {
          const newWindow = window.open(
            data.url,
            "_blank",
            "noopener,noreferrer",
          );

          if (newWindow) {
            newWindow.opener = null;
          }
        }
      }}
      className="dropdown-language"
      classNamePrefix="dropdown-language"
      aria-label={intl.formatMessage({ id: "navigation.dkms_websites" })}
      styles={{
        control: (styles: CSSProperties) => ({ ...styles, ...maxWidthElements, ...cursorPointer }),
        menu: (styles: CSSProperties) => ({ ...styles, ...maxWidthElements, ...cursorPointer }),
      }}
    />
  );
};

export default DropdownLanguage;
